import { render, staticRenderFns } from "./TakeOutAdmin.vue?vue&type=template&id=3f3cf594"
import script from "./TakeOutAdmin.vue?vue&type=script&lang=js"
export * from "./TakeOutAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports